import Request from '@/utils/request';

// 获取子集tab
export const subjectTabData = async (data) => {
  const { resultData } = await Request.post(
    '/gw/generic/jimu/h5/m/feedFlowOfSubject',
    {
      ...data,
    }
  );
  return { resultData }
}

// 获取品
export const productData = async (data) => {
  const { resultData } = await Request.post(
    '/gw2/generic/CreatorSer/h5/m/getProductTopicModule',
    {
      ...data,
    }
  );
  return { resultData }
}

// 合集tab
export const allTab = async (data) => {
  const { resultData } = await Request.post(
    '/gw2/generic/CreatorSer/h5/m/querySpecialCompilationTopicHeadInfo',
    {
      ...data,
    }
  );
  return { resultData }
}

